export default {
    path: '/production',
    name: 'Production',
    component: () => import('@/layout/index.vue'),
    redirect: {
        name: 'ProductionCall',
    },
    meta: {
        title: '生产',
        icon: 'iconfont icon-jiancaixuangou',
        role: 'BACK_MENU1'
    },
    children: [{
            path: '/whInventory',
            name: 'WhInventory',
            meta: {
                title: "库存",
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M1'
            },
            component: () => import('@/views/Production/WhInventory.vue')
        },
        {
            path: '/productionCall',
            name: 'ProductionCall',
            meta: {
                title: '生产叫料',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M2'
            },
            component: () => import('@/views/Production/ProductionCall.vue'),
        },
        {
            path: '/materialDistributionDetails',
            name: 'MaterialDistributionDetails',
            meta: {
                title: '配送详情',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M3'
            },
            component: () => import('@/views/Production/MaterialDistributionDetails.vue'),
        },
        {
            path: '/materialOnlineOrReturn',
            name: 'MaterialOnlineOrReturn',
            meta: {
                title: '通道库存',
                icon: 'el-icon-menu',
                role: 'BACK_MENU1_M4'
            },
            component: () => import('@/views/Production/MaterialOnlineOrReturn.vue'),
        },
        // {
        //     path: '/FinishedProductHanding',
        //     name: 'FinishedProductHanding',
        //     meta: {
        //         title: '成品搬运',
        //         icon: 'el-icon-menu',
        //         role: 'BACK_MENU1_M7'
        //     },
        //     component: () => import('@/views/Production/FinishedProductHanding.vue'),
        // },
        // {
        //     path: '/ProductionMissionQuery',
        //     name: 'ProductionMissionQuery',
        //     meta: {
        //         title: '点对点搬运',
        //         icon: 'el-icon-menu',
        //         role: 'BACK_MENU1_M8'
        //     },
        //     component: () => import('@/views/Production/ProductionMissionQuery.vue'),
        // },
        // {
        //     path: '/lineSupermarket',
        //     name: 'LineSupermarket',
        //     meta: {
        //         title: '线边超市',
        //         icon: 'el-icon-menu',
        //         role: 'BACK_MENU1_M5'
        //     },
        //     component: () => import('@/views/Production/LineSupermarket.vue'),
        // },
    ],
}